<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";

  .mapping-grid {
    display: grid;
    gap: utils.in_rem(25px);
    padding: utils.in_rem(32px) 0 utils.in_rem(32px) utils.in_rem(50px);

    .map {
      display: grid;
      gap: utils.in_rem(12px);
    }
  }
</style>

<script>
  import { writable } from "svelte/store";
  import CustomTabs from "../../../components/shared/CustomTabs.svelte";
  import SettingMappingRow from "../../../components/shared/MappingGrid/SettingMappingRow.svelte";
  import TabContent from "../../../components/shared/TabContent.svelte";
  import { activeProviderConfigStore, integrationStore } from "../../../stores";

  $: targetLabel = $integrationStore.getProviderTitle();

  $: tabItems =
    $activeProviderConfigStore?.syncKinds?.map((kind, index) => ({
      label: kind === "ClientContact" ? "CONTACT" : kind.toUpperCase(),
      slot: `tab${index}`,
      kind,
    })) || [];

  let currentType = writable("");

  $: if (tabItems.length > 0 && !$currentType)
    currentType.set(tabItems[0].kind);

  $: [setting] =
    $integrationStore
      .getSettings("notetaker", $currentType)
      .filter((item) => item.key.endsWith("notetakerMeetingNoteType")) || [];
</script>

<div class="notetaker-note-mapping">
  <CustomTabs {tabItems} bind:currentType />
  <TabContent
    hasData={!!setting}
    tabCount={tabItems.length}
    emptyMessage="No note mappings available for this type."
  >
    <div class="mapping-grid">
      <SettingMappingRow sourceLabel="SourceWhale" {targetLabel} header />
      <div class="map">
        <SettingMappingRow {setting} type={$currentType} />
      </div>
    </div>
  </TabContent>
</div>
